"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _NavbarUsernameDropdown = _interopRequireDefault(require("../elements/NavbarUsernameDropdown"));

var _NavBar = _interopRequireDefault(require("../elements/NavBar"));

var _NavbarSignout = _interopRequireDefault(require("../elements/NavbarSignout"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DropdownItem = _interopRequireDefault(require("../../elements/DropdownItem"));

var _NavigationVertical = _interopRequireDefault(require("../elements/NavigationVertical"));

var _NavigationLinks = _interopRequireDefault(require("../elements/NavigationLinks"));

var _DesktopTabletView = _interopRequireDefault(require("../../elements/view/DesktopTabletView"));

var _IconNavigationLink = _interopRequireDefault(require("../elements/IconNavigationLink"));

var _MobileView = _interopRequireDefault(require("../../elements/view/MobileView"));

var _MobileNavBigLink = _interopRequireDefault(require("../elements/MobileNavBigLink"));

var _HorizontalBarForVerticalNav = _interopRequireDefault(require("./HorizontalBarForVerticalNav"));

var _BestLink = _interopRequireDefault(require("../../elements/links/BestLink"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Theme = _interopRequireDefault(require("../../themes/Theme"));

var _NavbarDropdown = _interopRequireDefault(require("../elements/NavbarDropdown"));

var _NavigationDropdownLink = _interopRequireDefault(require("../elements/NavigationDropdownLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NavbarSignoutLink = (0, _styledComponents["default"])(_BestLink["default"]).withConfig({
  displayName: "VerticalNavigationFromConfig__NavbarSignoutLink",
  componentId: "k9ajkx-0"
})(["display:block;z-index:1053 !important;padding:0.25rem 1.5rem;&&&{text-decoration:none;}"]);
var NavbarSignoutItem = (0, _styledComponents["default"])(_DropdownItem["default"]).withConfig({
  displayName: "VerticalNavigationFromConfig__NavbarSignoutItem",
  componentId: "k9ajkx-1"
})(["z-index:1053 !important;"]);
var DefaultStyles = {
  navBarStyle: {
    marginLeft: 0
  },
  iconNavLinkStyle: {
    width: 68
  }
};
/**
 * A vertical navigation based on the navigation configuration
 */

var VerticalNavigationFromConfig = function VerticalNavigationFromConfig(_ref) {
  var _ref$config = _ref.config,
      title = _ref$config.title,
      displayEnvIndicator = _ref$config.displayEnvIndicator,
      loggedIn = _ref$config.loggedIn,
      username = _ref$config.username,
      usernameDropdownLinks = _ref$config.usernameDropdownLinks,
      navigationLinks = _ref$config.navigationLinks,
      logo = _ref$config.logo,
      builds = _ref$config.builds,
      env = _ref$config.env,
      isProd = _ref$config.isProd,
      styles = _ref$config.styles,
      pathname = _ref.location.pathname;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      mobileNavOpen = _useState2[0],
      setMobileNavOpen = _useState2[1];

  var toggleMobileNav = function toggleMobileNav() {
    setMobileNavOpen(!mobileNavOpen);
  };

  var checkForActive = function checkForActive(to) {
    return pathname === to;
  };

  var CompStyles = _objectSpread({}, DefaultStyles, {}, styles);

  return _react["default"].createElement("div", {
    className: "d-flex",
    style: {
      background: _Theme["default"]["white"]
    }
  }, _react["default"].createElement(_NavBar["default"], {
    env: env,
    vertical: true,
    displayEnvIndicator: displayEnvIndicator
  }, _react["default"].createElement(_NavbarSignout["default"], {
    loggedIn: loggedIn,
    color: _Theme["default"]["mlb-blue"],
    displayEnvIndicator: displayEnvIndicator
  }, _react["default"].createElement(_NavbarUsernameDropdown["default"], {
    username: username,
    color: _Theme["default"]["white"]
  }, _react["default"].createElement(_react["default"].Fragment, null, usernameDropdownLinks && usernameDropdownLinks.map(function (_ref2) {
    var name = _ref2.name,
        to = _ref2.to,
        onClick = _ref2.onClick,
        _ref2$visible = _ref2.visible,
        visible = _ref2$visible === void 0 ? true : _ref2$visible;
    return visible && to && to.length ? _react["default"].createElement(NavbarSignoutLink, {
      to: to,
      onClick: onClick,
      key: name
    }, name) : _react["default"].createElement(NavbarSignoutItem, {
      onClick: onClick,
      key: name
    }, name);
  })))), _react["default"].createElement(_NavigationVertical["default"], {
    loggedIn: loggedIn,
    isLoginTab: !loggedIn
  }, _react["default"].createElement(_NavigationLinks["default"], {
    open: mobileNavOpen,
    isProd: isProd,
    headerHeight: 38
  }, navigationLinks.map(function (_ref3) {
    var to = _ref3.to,
        icon = _ref3.icon,
        name = _ref3.name,
        subLinks = _ref3.subLinks;
    return _react["default"].createElement(_IconNavigationLink["default"], {
      key: name,
      toggleMobileNav: mobileNavOpen,
      to: to,
      icon: icon,
      tooltip: name,
      name: name,
      active: checkForActive(to),
      subLinks: subLinks,
      styles: CompStyles
    });
  }), _react["default"].createElement(_MobileView["default"], null, _react["default"].createElement(_NavbarDropdown["default"], {
    title: username
  }, usernameDropdownLinks && usernameDropdownLinks.map(function (_ref4) {
    var name = _ref4.name,
        to = _ref4.to,
        onClick = _ref4.onClick,
        _ref4$visible = _ref4.visible,
        visible = _ref4$visible === void 0 ? true : _ref4$visible;
    return visible && _react["default"].createElement(_NavigationDropdownLink["default"], {
      key: name,
      to: to,
      name: name,
      isActive: checkForActive(to),
      mobileNavOpen: mobileNavOpen,
      toggleMobileNav: toggleMobileNav,
      onClick: onClick
    });
  })))))), _react["default"].createElement(_HorizontalBarForVerticalNav["default"], {
    title: title,
    loggedIn: loggedIn,
    logo: logo,
    builds: builds,
    toggleMobileNav: toggleMobileNav,
    mobileNavOpen: mobileNavOpen
  }));
};

var DropDownShape = {
  name: _propTypes["default"].string.isRequired,
  to: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  visible: _propTypes["default"].bool
};
VerticalNavigationFromConfig.propTypes = {
  config: _propTypes["default"].shape({
    title: _propTypes["default"].string,
    env: _propTypes["default"].string.isRequired,
    isProd: _propTypes["default"].bool.isRequired,
    loggedIn: _propTypes["default"].bool.isRequired,
    username: _propTypes["default"].string.isRequired,
    displayEnvIndicator: _propTypes["default"].bool.isRequired,
    usernameDropdownLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape(DropDownShape)),
    navigationLinks: _propTypes["default"].arrayOf(_propTypes["default"].shape(DropDownShape)),
    logo: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]),
    logoText: _propTypes["default"].string,
    builds: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      build: _propTypes["default"].string.isRequired
    })),
    tabletSupport: _propTypes["default"].bool,
    styles: _propTypes["default"].object
  }).isRequired,
  location: _propTypes["default"].shape({
    pathname: _propTypes["default"].string.isRequired
  }).isRequired
};

var _default = (0, _reactRouterDom.withRouter)(VerticalNavigationFromConfig);

exports["default"] = _default;